import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserRoles } from './constant.service';
import { HasPermissionService } from './has-permission.service';

@Injectable({
  providedIn: 'root',
})
export class ActivateUsers  {
  constructor(
    private router: Router,
    private hasPermission: HasPermissionService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    var roles: UserRoles[] = [
      UserRoles.User,
      UserRoles.HelpDeskUser,
      UserRoles.AdminUser,
      UserRoles.MspAdmin,
      UserRoles.SuperAdmin,
    ];
    return this.hasPermission.allowAccessAsync(roles, route);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return this.canActivate(route, state);
  }
}
